import React, { PureComponent } from 'react'
import { pageData } from 'decorators'
import { connect } from 'react-redux'
import PhaseActions from 'store/redux/phase'
import { translate } from 'react-i18next'

import { FirstPage } from './FirstPage'
import { SecondPage } from './SecondPage'
import { Tip } from './Tip'
import './Tour.css'

@pageData({ title: 'Tour' })
@connect(
    null,
    {
        endPhase: PhaseActions.endPhase
    }
)
@translate()
export class Tour extends PureComponent {
    state = {
        step: 0,
        holeClosed: true
    }

    componentWillMount() {
        const { t } = this.props
        this.loaded = false
        this.holePositions = [{ cx: 0, cy: 0, rx: 0, ry: 0 }]
        this.tips = [
            { text: t('tour.tips.credits'), cursor: 'up-right' },
            { text: t('tour.tips.time'), cursor: 'up-right' },
            { text: t('tour.tips.items'), cursor: 'down-right' },
            { text: t('tour.tips.charts'), cursor: 'right-down' }
        ]
    }
    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions)
        setTimeout(this.updateDimensions, 250)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    nextStep = () => {
        const { step } = this.state

        if (step >= this.tips.length - 1) {
            this.props.endPhase()
        } else {
            this.setState({ step: step + 1 })
        }
    }

    updateDimensions = () => {
        const windowWidth = window.innerWidth
        const windowHeight = window.innerHeight
        this.holePositions = [
            getHolePosition('tour-step-1', windowWidth, windowHeight, { x: 3, y: 1.5 }),
            getHolePosition('tour-step-2', windowWidth, windowHeight, { x: 3, y: 1.5 }),
            getHolePosition('tour-step-3', windowWidth, windowHeight, { x: -5, y: 5 }),
            getHolePosition('tour-step-4', windowWidth, windowHeight, { x: 8, y: 4 })
        ]
        this.tips = [
            {
                ...this.tips[0],
                right: `${(100 - this.holePositions[0].cx) - 2}%`,
                top: `${this.holePositions[0].cy + this.holePositions[0].ry + 2}%`,
            },
            {
                ...this.tips[1],
                right: `${(100 - this.holePositions[1].cx) - 2}%`,
                top: `${this.holePositions[1].cy + this.holePositions[1].ry + 2}%`,
            },
            {
                ...this.tips[2],
                left: `${5}%`,
                bottom: `${(100 - this.holePositions[2].cy) + this.holePositions[2].ry + 2}%`,
            },
            {
                ...this.tips[3],
                right: `${(100 - this.holePositions[3].cx) + this.holePositions[3].rx + 2}%`,
                top: `${this.holePositions[3].cy - this.holePositions[3].ry + 2}%`,
            }
        ]
        if (!this.loaded) {
            setTimeout((() => this.setState({ holeClosed: false })), 100)
        }
        this.loaded = true
        this.forceUpdate()
    }

    renderHole = () => {
        const { step, holeClosed } = this.state
        if (this.loaded) {
            const { cx, cy, rx: posRx, ry: posRy } = this.holePositions[step]
            const rx = holeClosed ? 0 : posRx
            const ry = holeClosed ? 0 : posRy
            return (
                <path
                    id="hole"
                    d={`M${cx} ${cy - ry} A ${rx} ${ry} 0 0 0 ${cx} ${cy + ry} A ${rx} ${ry} 0 0 0 ${cx} ${cy - ry}`}
                    fill="black"
                    filter="url(#filter)"
                />
            )
        }
        return null
    }
    renderTip = (tipProps, i) => {
        const { step, holeClosed } = this.state
        return (
            <Tip key={i} className={{ Hide: holeClosed || i !== step }} {...tipProps} />
        )
    }

    render() {
        const { step } = this.state

        return (
            <div className="Tour" onClick={this.nextStep}>
                <div className="Tour-MockPages">
                    <FirstPage className={{ Hide: step > 1 }} />
                    <SecondPage className={{ Hide: step < 2 }} />
                </div>
                <div className="Tour-Overlay">
                    <svg viewBox="0 0 100 100" preserveAspectRatio="none">
                        <defs>
                            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient">
                                <stop stopColor="#7BADA1" offset="0%" />
                                <stop stopColor="#0A1C18" offset="100%" />
                            </linearGradient>
                            <filter x="-25%" y="-25%" width="150%" height="150%" filterUnits="objectBoundingBox" id="filter">
                                <feGaussianBlur stdDeviation="1" in="SourceGraphic" />
                            </filter>
                            <mask id="hole">
                                <rect x="0" y="0" width="100" height="100" fill="white" />
                                {this.renderHole()}
                            </mask>
                        </defs>
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.9">
                            <rect mask="url(#hole)" fill="url(#linearGradient)" x="0" y="0" width="100" height="100" />
                        </g>
                    </svg>
                </div>
                {this.tips.map(this.renderTip)}
            </div>
        )
    }
}

function getHolePosition(id, windowWidth, windowHeight, extraMargin = { x: 0, y: 0 }) {
    const element = document.getElementById(id)
    const { top, left, width, height } = element.getBoundingClientRect()
    return {
        cx: (left + (width / 2)) * (100 / windowWidth),
        cy: (top + (height / 2)) * (100 / windowHeight),
        rx: ((width / 2) * (100 / windowWidth)) + extraMargin.x,
        ry: ((height / 2) * (100 / windowHeight)) + extraMargin.y
    }
}



// WEBPACK FOOTER //
// src/pages/Tour/Tour.js